// extracted by mini-css-extract-plugin
module.exports =  {"container":"SendNote-ujk6__container","send-to":"SendNote-jvgM__send-to","group-selector":"SendNote-sNFw__group-selector"};